export const types = {
  OPEN_PROFIT_ITEM_MODAL: 'modules/quotes/modals/OPEN_PROFIT_ITEM_MODAL',
  CLOSE_PROFIT_ITEM_MODAL: 'modules/quotes/modals/CLOSE_PROFIT_ITEM_MODAL',

  LIVE_PROFIT_ITEM_PREVIEW_REQUEST:
    'modules/quotes/modals/LIVE_PROFIT_ITEM_PREVIEW_REQUEST',
  LIVE_PROFIT_ITEM_PREVIEW_SUCCESS:
    'modules/quotes/modals/LIVE_PROFIT_ITEM_PREVIEW_SUCCESS',
  LIVE_PROFIT_ITEM_PREVIEW_ERROR:
    'modules/quotes/modals/LIVE_PROFIT_ITEM_PREVIEW_ERROR',

  RECEIVE_OVERRIDES: 'modules/quotes/modals/RECEIVE_PROFIT_ITEM_OVERRIDES',
};

export const profitItemModal = {
  open: ({ cells, isReadOnly, profitItem }) => {
    return {
      type: types.OPEN_PROFIT_ITEM_MODAL,
      payload: {
        cells,
        isReadOnly,
        profitItem,
      },
    };
  },
  close: () => ({
    type: types.CLOSE_PROFIT_ITEM_MODAL,
  }),
  receiveOverrides: ({ nextOverrides }) => ({
    type: types.RECEIVE_OVERRIDES,
    payload: { nextOverrides },
  }),
};

export const liveProfitItemPreview = {
  request: ({ profitItemId, newOverrides }) => ({
    type: types.LIVE_PROFIT_ITEM_PREVIEW_REQUEST,
    payload: { profitItemId, overrides: newOverrides },
  }),
  success: (profitItem) => ({
    type: types.LIVE_PROFIT_ITEM_PREVIEW_SUCCESS,
    payload: profitItem,
  }),
  error: () => ({
    type: types.LIVE_PROFIT_ITEM_PREVIEW_ERROR,
  }),
};
